import { OnInit, AfterViewInit, Renderer2, ChangeDetectorRef, OnDestroy, ElementRef } from '@angular/core';
import { BdGraph } from 'src/lib/graph/graph.model';
import { Subject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TreeTheme } from '../tree/tree.component';
var TreeSearchComponent = /** @class */ (function () {
    function TreeSearchComponent(renderer, changeDetectorRef, elementRef) {
        this.renderer = renderer;
        this.changeDetectorRef = changeDetectorRef;
        this.elementRef = elementRef;
        this._query = '';
        this.theme = TreeTheme.Dark;
        this.searchResults = [];
        this.searchHeight = 0;
        this.ngUnsubscribe = new Subject();
    }
    Object.defineProperty(TreeSearchComponent.prototype, "query", {
        get: function () {
            return this._query;
        },
        set: function (value) {
            this._query = value || '';
            if (this.query.length) {
                this.handleQueryChange();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeSearchComponent.prototype, "viewGraph", {
        get: function () {
            return this._viewGraph;
        },
        set: function (value) {
            this._viewGraph = value;
            this.changeDetectorRef.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    TreeSearchComponent.prototype.ngOnInit = function () {
    };
    TreeSearchComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        // Window has resized, let the 3D canvas know
        this.renderer.listen('window', 'resize', function (event) {
            _this.resize();
        });
    };
    TreeSearchComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    TreeSearchComponent.prototype.handleQueryChange = function () {
        this.searchResults = this.search(this.query);
        this.resize();
    };
    TreeSearchComponent.prototype.resize = function () {
        var _this = this;
        this.getSearchHeight()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (height) {
            _this.searchHeight = height;
            _this.changeDetectorRef.markForCheck();
        });
    };
    TreeSearchComponent.prototype.getSearchHeight = function () {
        var _this = this;
        var e = this.elementRef;
        return new Observable(function (observer) {
            setTimeout(function () {
                var offsetHeight = _this.elementRef.nativeElement.offsetHeight;
                if (offsetHeight != null) {
                    observer.next(offsetHeight);
                    observer.complete();
                }
            });
        });
    };
    TreeSearchComponent.prototype.search = function (query) {
        query = query.toLowerCase();
        var results = Object.values(this.viewGraph.nodes)
            .filter(function (node) { return node.label.toLowerCase().indexOf(query) >= 0; })
            .sort(function (a, b) {
            return a.label.localeCompare(b.label);
        })
            .sort(function (a, b) {
            return Math.sign(a.getDepth() - b.getDepth());
        });
        return results;
    };
    TreeSearchComponent.prototype.trackTreeNode = function (index, node) {
        return node.id;
    };
    return TreeSearchComponent;
}());
export { TreeSearchComponent };
